export default "__VITE_ASSET__CGBXZEgt__"